<template>
  <div id="footer" class="container-fluid">
    <div class="container-footer clearfix">

      <div class="footer-view">
        <div class="logo-concent hidden-xs">
          <div class="logo-img">
            <img src="http://xcx.qk-p.com/static/xcx_zmp/icon/guanwang/logo2.png" alt="" />
          </div>
          <div class="logo-line"></div>
          <div class="logo-tetx">了解更多企业动态,关注BCM媒体矩阵：</div>
        </div>

        <div class="contact-type">
          <div class="contact-icon" v-for="(item,index) in contact" :key="index">
            <img class="contact-icon-img" :src="item.icon" alt="" />
            <img class="contact-icon-img2" :src="item.iconActive" alt="" />
            <div class="contact-icon-pop">
              <img class="contact-icon-pop-img" :src="item.code" alt="" />
              <div class="contact-icon-pop-txt">{{item.text}}</div>
            </div>
          </div>
        </div>
      </div>
      <div class="footer-view footer-view-2">
        <div class="footer-v-text-nav">
          <div class="footer-v-t-list">
            <div class="footer-v-t-item">关于BCM</div>
            <router-link to='/CompanyIntroduction'>
              <div class="footer-v-t-item footer-v-t-item-n">公司简介</div>
            </router-link>
            <router-link to='/'>
              <div class="footer-v-t-item footer-v-t-item-n">应用场景</div>
            </router-link>
          </div>
          <div class="footer-v-t-list">
            <div class="footer-v-t-item">服务支持</div>
            <router-link to='/software'>
              <div class="footer-v-t-item footer-v-t-item-n">产品技术支持</div>
            </router-link>
            <router-link to='/Service'>
              <div class="footer-v-t-item footer-v-t-item-n">售后服务支持</div>
            </router-link>
          </div>
          <div class="footer-v-t-list">
            <div class="footer-v-t-item">媒体中心</div>
            <router-link to='/newsinformation'>
              <div class="footer-v-t-item footer-v-t-item-n">新闻资讯</div>
            </router-link>
            <router-link to='/Knowledge'>
              <div class="footer-v-t-item footer-v-t-item-n">资料库</div>
            </router-link>
          </div>
        </div>
        <div class="footer-v-wx">
          <div class="footer-v-wx-item">
            <div class="footer-v-wx-item-img">
              <img src="http://xcx.qk-p.com/static/xcx_zmp/icon/guanwang/code_1.png" alt="" />
            </div>
            <div class="footer-v-wx-item-text">BCM平台投放端</div>
          </div>
          <div class="footer-v-wx-item">
            <div class="footer-v-wx-item-img">
              <img src="http://xcx.qk-p.com/static/xcx_zmp/icon/guanwang/code_2.png" alt="" />
            </div>
            <div class="footer-v-wx-item-text">BCM商户应用端</div>
          </div>
        </div>
        <div class="footer-contact-us">
          <div class="footer-contact-us-text1">订阅我们</div>
          <div class="footer-contact-us-text2">第一时间获取BCM最新动态</div>
          <div class="footer-contact-us-text3">400-0591-899</div>
          <div class="footer-contact-us-text2">周一至周日 09：00-22：00</div>
        </div>

      </div>
      <div class="footer-view footer-view-border clearfix">
        <div class="footer-view-bq">闽ICP备17027072号-1 | 版权所有@2016 Fuzhou Lanke Technology Co., Ltd. |
          技术支持·福州览客科技有限公司
        </div>
      </div>


    </div>
  </div>
</template>
<script>
  export default {
    name: "Footer",
    data() {
      return {
        contact: [{
            icon: "http://xcx.qk-p.com/static/xcx_zmp/icon/guanwang/contact_1_active.png",
            iconActive: "http://xcx.qk-p.com/static/xcx_zmp/icon/guanwang/contact_1.png",
            code: "http://xcx.qk-p.com/static/xcx_zmp/icon/guanwang/code_douyin.png",
            text: '扫码关注抖音号'
          },
          {
            icon: "http://xcx.qk-p.com/static/xcx_zmp/icon/guanwang/contact_2_active.png",
            iconActive: "http://xcx.qk-p.com/static/xcx_zmp/icon/guanwang/contact_2.png",
            code: "http://xcx.qk-p.com/static/xcx_zmp/icon/guanwang/code_shiping.jpg",
            text: '扫码关注微信视频号'
          },
          {
            icon: "http://xcx.qk-p.com/static/xcx_zmp/icon/guanwang/contact_3_active.png",
            iconActive: "http://xcx.qk-p.com/static/xcx_zmp/icon/guanwang/contact_3.png",
            code: "http://xcx.qk-p.com/static/xcx_zmp/icon/guanwang/code_weibo.png",
            text: '扫码关注微博号'
          },
          {
            icon: "http://xcx.qk-p.com/static/xcx_zmp/icon/guanwang/contact_4_active.png",
            iconActive: "http://xcx.qk-p.com/static/xcx_zmp/icon/guanwang/contact_4.png",
            code: "http://xcx.qk-p.com/static/xcx_zmp/icon/guanwang/code_wx.jpg",
            text: '扫码关注微信公众号'
          },
          {
            icon: "http://xcx.qk-p.com/static/xcx_zmp/icon/guanwang/contact_5_active.png",
            iconActive: "http://xcx.qk-p.com/static/xcx_zmp/icon/guanwang/contact_5.png",
            code: "http://xcx.qk-p.com/static/xcx_zmp/icon/guanwang/code_xhs.png",
            text: '扫码关注小红书'
          }
        ]
      };
    }
  };
</script>
<style scoped>
  #footer {
    width: 100%;
    height: 100%;
    color: #fff;
    background: #202736;
    /* overflow: hidden; */
    text-align: center;
    padding: 100px 0 20px;
  }

  .logo {
    width: 95px;
    height: 45px;
    margin: 50px 0 20px;
  }

  .title {
    font-size: 25px;
    margin-bottom: 20px;
  }

  .address_tel_fax {
    color: #d3d3d3;
    font-size: 14px;
    margin: 10px 0;
  }

  .email_wx {
    color: #d3d3d3;
    font-size: 14px;
  }

  .copy {
    color: #d3d3d3;
    font-size: 14px;
    margin: 50px 0 10px;
  }

  .container-footer {
    /* width: 100%; */
    margin: 0 16%;
  }

  .footer-view {
    /* overflow: hidden; */
    width: 100%;
    margin-bottom: 100px;
    display: flex;
    justify-content: space-between;
  }

  /* .clearfix::after {
    content: "";
    display: table;
    clear: both;
  } */

  .logo-concent {
    /* float: left; */
    padding: 13px 0;
  }

  .logo-img {
    float: left;
    width: 100px;
  }

  .logo-img img {
    width: 100%;
    height: auto;
  }

  .logo-line {
    float: left;
    margin: 2px 10px 0;
    width: 1px;
    height: 30px;
    background-color: #414141;
  }

  .logo-tetx {
    float: left;
    color: #9FA0A0;
    font-size: 14px;
    line-height: 33px;
  }

  .contact-type {
    /* float: right; */
    display: flex;
    width: 50%;
    justify-content: space-between;
  }

  .contact-icon {
    position: relative;
    float: left;
    width: 50px;
    /* margin-right: 20%; */
    cursor: pointer;
  }

  .contact-icon:hover .contact-icon-img {
    display: none;
  }

  .contact-icon:hover .contact-icon-img2 {
    display: block;
  }

  .contact-icon:hover .contact-icon-pop {
    display: block;
  }

  .contact-icon .contact-icon-img {
    width: 100%;
    height: auto;
  }

  .contact-icon .contact-icon-img2 {
    width: 100%;
    height: auto;
    display: none;
  }

  .contact-icon-pop {
    display: none;
    position: absolute;
    top: -160px;
    left: -35px;
    width: 120px;
    background: #fff;
    box-shadow: 0 0 3px 1px #ccc;
  }

  .contact-icon-pop-img {
    display: block;
    width: 100%;
  }

  .contact-icon-pop-txt {
    text-align: center;
    font-size: 12px;
    padding: 5px 0;
    color: #000;
  }

  .footer-v-text-nav {
    /* float: left; */
    /* margin-right: 50px; */
    display: flex;
    width: 30%;
    justify-content: space-between;
  }

  .footer-v-t-list {
    /* float: left; */
    /* margin-right: 100px; */
  }

  .footer-v-t-item {
    color: #fff;
    font-size: 14px;
    font-weight: bold;
    text-align: left;
    margin-bottom: 20px;
  }

  .footer-v-t-item-n {
    font-weight: normal;
    cursor: pointer;
    color: #9FA0A0;
  }

  .footer-v-wx {
    /* float: left; */
    /* padding-left: 80px; */
    display: flex;
    /* width: 20%; */
    justify-content: space-between;
  }

  .footer-v-wx-item {
    /* float: left; */
    margin-right: 30px;
  }

  .footer-v-wx-item-img {
    width: 100px;
    margin-bottom: 10px;
  }

  .footer-v-wx-item-img img {
    display: block;
    width: 100%;
    height: auto;
  }

  .footer-v-wx-item-text {
    color: #6A6A6A;
    font-size: 14px;
  }

  .footer-contact-us {
    /* float: left; */
  }

  .footer-contact-us-text1 {
    text-align: left;
    color: #fff;
    font-size: 14px;
    margin-bottom: 10px;
  }

  .footer-contact-us-text2 {
    text-align: left;
    color: #9FA0A0;
    font-size: 14px;
    margin-bottom: 10px;
  }

  .footer-contact-us-text3 {
    text-align: left;
    color: #fff;
    font-size: 30px;
    margin-bottom: 10px;
  }

  .footer-view-border {
    border-top: 1px solid #414141;
  }

  .footer-view-bq {
    text-align: left;
    color: #9FA0A0;
    font-size: 14px;
    padding: 50px 0 0 0;
  }


  @media screen and (max-width: 1000px) {
    #footer {
      padding-top: 50px;
    }

    .contact-type {
      width: 100%;
    }

    .footer-view {
      margin-bottom: 50px;
    }

    .footer-view-2.footer-view {
      display: block;

    }

    .container-footer {
      margin: 0 8%;
    }

    .footer-v-text-nav {
      width: 100%;
      margin-bottom: 30px;
    }

    .footer-v-wx {
      justify-content: space-around;
      width: 100%;
      margin-bottom: 30px;
    }

    .footer-contact-us {
      display: none;
      width: 100%;
      text-align: center;
    }

    .footer-v-wx-item {
      margin-right: 0;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/Footer.vue